import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useCallback, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import BirthdayDocumentForm from './form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';

interface BirthdayDocumentProps {
  isAire?: boolean;
  isTransferNew?: boolean;
  isTransferAggregation?: boolean;
  disabled?: boolean;
  isBornSolo?: boolean;
}

const BirthdayDocumentComponent = ({
  isAire,
  isTransferNew,
  isTransferAggregation,
  disabled,
  isBornSolo,
}: BirthdayDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onFieldBirthdayDocumentChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('birthdayDocument', {
        ...formContext.values.birthdayDocument,
        [key]: value,
      });
    },
    [formContext.values.birthdayDocument, formContext.setFieldValue]
  );

  const onFieldsBirthdayDocumentChange = useCallback(
    (values) => {
      formContext.setFieldValue('birthdayDocument', {
        ...formContext.values.birthdayDocument,
        ...values,
      });
    },
    [formContext.values.birthdayDocument, formContext.setFieldValue]
  );

  const resetForm = useCallback(() => {
    formContext.setFieldValue('birthdayDocument', { transcript: false });
  }, [formContext.values.birthdayDocument, formContext.setFieldValue]);

  const errorBirthdayDocument = useMemo(() => {
    return !!formContext.errors.birthdayDocument;
  }, [formContext.errors.birthdayDocument]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-birthday-document-content"
        id="panel-person-birthday-document-header"
        expandIcon={<ExpandMore />}
      >
        {errorBirthdayDocument ? <Close color="error" /> : <Check color="success" />}
        <Typography>Atto di nascita</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <BirthdayDocumentForm
          onChange={onFieldBirthdayDocumentChange}
          birthday={formContext.values.generality?.birthDate}
          values={formContext.values.birthdayDocument}
          errors={
            formContext.errors.birthdayDocument as FormikErrors<
              CommonInterfaceSubscription['birthdayDocument']
            >
          }
          touched={
            formContext.touched.birthdayDocument as FormikTouched<
              CommonInterfaceSubscription['birthdayDocument']
            >
          }
          initialValues={formContext.initialValues.birthdayDocument}
          resetForm={resetForm}
          onChangeValues={onFieldsBirthdayDocumentChange}
          isAire={isAire}
          isTransferNew={isTransferNew || isTransferAggregation}
          disabled={disabled}
          isBornSolo={isBornSolo}
        />
      </AccordionDetails>
    </Accordion>
  );
};

BirthdayDocumentComponent.displayName = 'Accordion Birthday document component';

const BirthdayDocument = memo(BirthdayDocumentComponent);

export default BirthdayDocument;
